'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isIE11 = isIE11;
exports.isFirefox = isFirefox;
function isIE11() {
  return window.navigator && navigator.userAgent && navigator.userAgent.indexOf('Trident/') >= 0;
}

function isFirefox() {
  return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/utils/BrowserTest.js
// module id = 142
// module chunks = 0